import { Slot } from '../../api/slots';
import { SpotLayoutItem } from '../../api/spotLayoutItems';

export function getDefaultSpotLayoutLabel(spotLayoutItem: SpotLayoutItem, slots: Slot[]): string {
    const slot = slots.find((slot) => {
        return slot.id === spotLayoutItem.slot;
    });
    return slot ? slot.slot_nr : '';
}
